import React from "react";
import "@fontsource/albert-sans/100.css";
import "@fontsource/albert-sans/200.css";
import "@fontsource/albert-sans/300.css";
import "@fontsource/albert-sans/400.css";
import "@fontsource/albert-sans/500.css";
import "@fontsource/albert-sans/600.css";
import "@fontsource/albert-sans/700.css";
import "@fontsource/albert-sans/800.css";
import "@fontsource/albert-sans/900.css";
import { Redirect, BrowserRouter as Router, Switch } from "react-router-dom";

// Utils
import hexToRGBA from "./utils/hexToRGBA";
/** HOC */
import PublicRoute from "./pages/PublicRoute";
import PrivateRoute from "./pages/PrivateRoute";
import ResetPassword from "./pages/ResetPassword";
import NewResetPassword from "./pages/NewResetPassword";
import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import NewProfilePage from "./pages/NewProfilePage";
import Test from "./pages/Test";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StudentVerify from "./pages/StudentVerify";
import ViewStudent from "./pages/ViewStudent";
import Settings from "./pages/Settings";
import HEQCIS from "./pages/HEQCIS";
import StudentStatus from "./pages/StudentStatus";
import SystemAdministration from "./pages/SystemAdministration";
import AddNewUser from "./components/systemadministration/usermanagement/AddNewUser";
import EditUser from "./components/systemadministration/usermanagement/EditUser";
import PermissionManagement from "./pages/PermissionManagement";
import NoAccess from "./components/common/NoAccess";
import ProgramManagementCenter from "./pages/ProgramManagementCenter";
import ProjectCenter from "./pages/ProjectCenter";
import CareerLibrary from "./pages/CareerLibrary";
import Programs from "./pages/Programs";
import Appeals from "./pages/Appeals";

import Courses from "./pages/Courses";
import DetailCourses from "./components/courses/DetailCourses";
import BookedCourses from "./components/courses/BookedCourses";
import OpenCourseBookings from "./components/courses/OpenCourseBookings";
import ContentAssemblies from "./components/courses/ContentAssemblies";
import AssembliesDetails from "./components/courses/ContentAssembliesBlock/AssembliesDetails";
import ResourcePoolDetails from "./components/courses/ContentAssembliesBlock/ResourcePoolDetails";
import SupportAdministration from "./pages/SupportAdministration";
import AddTicket from "./components/supportadministration/AddTicket";
import ViewTicket from "./components/supportadministration/ViewTicket";
import AddNewCourse from "./components/courses/AddNewCourse";
import AuditTrail from "./components/studentsupport/studenthub/AuditTrail";
import CategoriesTabList from "./components/studentsupport/studenthub/CategoriesTab";
import AuditTrailBrand from "./components/systemadministration/BrandManagement/AuditTrail";
import AddNewBrand from "./components/systemadministration/BrandManagement/AddNewbrand";
import AddPortalSetting from "./components/systemadministration/BrandManagement/AddPortalSetting";
import EditBrand from "./components/systemadministration/BrandManagement/EditBrand";
import BrandManagement from "./pages/BrandManagement";
import ResourcesTabList from "./components/studentsupport/studenthub/ResourcesTab";
import DetailTab from "./components/systemadministration/BrandManagement/DetailTab";
import VisualsTab from "./components/systemadministration/BrandManagement/VisualsTab";
import SingleAuditTrailBrand from "./components/systemadministration/BrandManagement/SingleAuditTrail";
import AddQuestion from "./components/courses/smartAssessment/questionBank/AddQuestion";
import ResourcePoolSubCatDetails from "./components/courses/ContentAssembliesBlock/ResourcePoolSubCatDetails";

import NetsuiteManagement from "./pages/NetsuiteManagement";
import EmailManagement from "./pages/EmailManagement";

import Notification from "./pages/Notification";
import General from "./pages/General";
import ServerManagement from "./pages/ServerManagement";
import ClassManagement from "./pages/ClassManagement";
import CampusManagement from "./pages/CampusManagement";

import TicketSetting from "./pages/TicketSetting";

import AddAssessment from "./components/courses/smartAssessment/assessment/AddAssessment";
import LiveChat from "./components/studentsupport/studenthub/LiveChat";

import StudentAdministration from "./pages/StudentAdministration";
import ReRegistration from "./pages/ReRegistration";
import BookingManagement from './components/campusAdministration/bookingManagement/BookingManagement'
import ScheduleManagement from './components/campusAdministration/scheduleManagement/ScheduleManagement';
import SmartSignage from './components/campusAdministration/smartSignage/SmartSignage';
import Phone from "./pages/Phone";
import BannerPages from "./pages/BannerPages";
import DashBoardDesign1 from "./components/courses/DetailCoursesBlocks/DashBoardDesign1";
import CoursesDeonDesign from "./pages/CoursesDeonDesign";
import CoursesDeonDesignUnknown from "./pages/CoursesDeonDesignUnknown";
import ResourceManagement from "./pages/resourceManagement";
import { ExportPDF } from "./components/pmc/program/ExportPDF";
import LandingPage from "./components/common/LandingPage";
import CreateTab from "./components/studentsupport/studenthub/CreateTab";
import TabDetail from "./components/studentsupport/studenthub/TabDetail";
import DuplicateQuestion from "./components/courses/smartAssessment/questionBank/DuplicateQuestion";
import StudentHubManagement from "./components/studentsupport/studenthub";
import ExternalExamReg from "./pages/ExternalExamReg";
import { GetBrandColor } from "./services/ConfigServices";
import { connect } from "react-redux";
import { setBrandVisuals } from "./store/actions";
import ClassReport from "./pages/ClassReport";
import { DOMAIN_COLOR } from "./utils/Constants";
import FileSystem from "./components/common/FileSystem";
import TemplateTable from "./pages/TemplateTable";
import ProgramArticulations from "./pages/ProgramArticulations";
import IntakeCopy from "./pages/IntakeCopy";
// import RepositionElements from "./components/StudentAdministration/CertificateTemplates/RepositionElement";
import DuplicateTemplate from "././components/StudentAdministration/CertificateTemplates/DuplicateTemplate";
import GradeMix from "./pages/GradeMix";
import SoftphoneManagement from './pages/SoftphoneManagement';
import CertificateTemplate from "./pages/CertificateTemplate";
import Website from "./pages/WebsiteManagement";
import CreateBrandTemplate from "./components/website/addbrandtemplate/CreateBrandTemplate";
import AddWebsiteList from "./components/website/websitelist/AddWebsiteList";
import Events from "./pages/Events";
import LayoutNavigation from "./pages/LayoutNavigation";
import StaticPages from "./pages/StaticPages";
import CreateStaticPages from './components/pages/staticPages/CreateStaticPages';
import CampusPages from './pages/CampusPages';
import CreateCampusPages from './components/pages/campusPages/CreateCampusPages';
import LandingPageTabs from "./components/website/events/landingPageItem/LandingPageTabs";
import PopupsPages from "./pages/PopupsPages";
import CreatePopupsPages from "./components/pages/popupsPages/CreatePopupsPages";
import CategoryLandingpages from "./pages/CategoryLandingpages";
import CreateCategoryLandingPages from "./components/pages/CategoryLandingpages/CreateCategoryLandingPages";
import UpcomingEventsTabs from "./components/website/events/upcomingEventsItem/UpcomingEventsTabs";
import InfoPacksTabs from "./components/website/events/infoPacksItem/InfoPacksTabs";
import CategoryTabs from "./components/layoutNavigation/layoutCategories/CategoryTabs";
import CreateLayoutTestimonial from "./components/layoutNavigation/layoutTestimonials/createTestimonial/CreateLayoutTestimonial";
import CourseLandingPages from "./pages/CourseLandingPages";
import CreateCourseLandingPages from "./components/pages/CourseLandingpages/CreateCourseLandingPages";
import BlogAndNews from "./pages/BlogAndNews";
import CreateBlogAndNewsPages from "./components/pages/blogandnews/CreateBlogAndNewsPages";
import EmailsPages from "./pages/EmailsPages";
import CreateEmailsPages from "./components/emailspages/CreateEmailsPages";
import ProgrammeShortCourse from "./components/website/programmeAndShortCourse/ProgrammeShortCourse";
import PartnerManagement from "./pages/PartnerManagement";
import PartnerDetails from "./components/website/partners/PartnerDetails";
import AuditTrailPartner from "./components/website/partners/AuditTrails"
import CallDashboard from "./pages/CallDashboard";

/** map actions */
function mapDispatchToProps(dispatch) {
  return {
    setBrandVisuals: (payload) => dispatch(setBrandVisuals(payload)),
  };
}

/**
 * Redirects legacy course student gradebook URLs to Student Profile > Gradebook.
 */
const StudentGradebookRedirect = ({ match }) => (
  <Redirect to={`/studentAdministration/students/open/${match.params.stdId.split('?')[0]}/gradebook`} />
);

/** map state */

const mapStateToProps = (state) => ({
  brandVisualsConfig: state.brandVisuals.config,
});

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expired: false,
    };
    console.warn = () => { };
  }
  componentDidMount() {
    this.GetConfigurations();
  }
  GetConfigurations() {
    let domain = window.location.hostname;
    if (domain.startsWith("www.")) {
      domain = domain.slice(4);
    }
    if (domain == "localhost") {
      domain = DOMAIN_COLOR;
    }
    const parameter = {
      domain: domain,
    };
    GetBrandColor(parameter)
      .then((res) => {
        if (res.status === 200) {
          const resp = res.data;
          this.props.setBrandVisuals(resp);
          if (Object.keys(this.props.brandVisualsConfig).length) {
            const rgbaTopbarColor = hexToRGBA(
              this.props.brandVisualsConfig.topbar_color,
              0.2
            );
            const rgbaSidebarColor = hexToRGBA(
              this.props.brandVisualsConfig.sidebar_color,
              0.2
            );
            document.body.style.setProperty(
              "--topbar-color",
              this.props.brandVisualsConfig.topbar_color
            );
            document.body.style.setProperty(
              "--topbar-opacity-color",
              rgbaTopbarColor
            );
            document.body.style.setProperty(
              "--highlight-color",
              this.props.brandVisualsConfig.highlight_color
            );
            document.body.style.setProperty(
              "--sidebar-color",
              this.props.brandVisualsConfig.sidebar_color
            );
            document.body.style.setProperty(
              "--sidebar-opacity-color",
              rgbaSidebarColor
            );
            document.body.style.setProperty(
              "--hover-color",
              this.props.brandVisualsConfig.hover_color
            );
            document.body.style.setProperty(
              "--active-color",
              this.props.brandVisualsConfig.active_color
            );
            document.body.style.setProperty(
              "--login-header-color",
              this.props.brandVisualsConfig.login_header_color
            );
            document.body.style.setProperty(
              "--button-color",
              this.props.brandVisualsConfig.button_color
            );
            document.body.style.setProperty(
              "--button-hover-color",
              this.props.brandVisualsConfig.button_hover_color
            );
            document.body.style.setProperty(
              "--button-active-color",
              this.props.brandVisualsConfig.button_active_color
            );
          }
        }
      })
      .catch((err) => {
        console.log("Error fetching brand colors", err);
      });
  }
  render() {
    return (
      <Router>
        <ToastContainer />
        <Switch>
          <PrivateRoute
            exact
            path="/links/:page/:subPage?"
            component={LandingPage}
          />
          <PrivateRoute
            exact
            path="/support/studentBanners/:type/:id?"
            component={BannerPages}
          />
          <PublicRoute exact path="/" component={LoginPage} />
          <PublicRoute exact path="/forgotPassword" component={ResetPassword} />
          <PublicRoute
            exact
            path="/resetPassword/:id"
            component={NewResetPassword}
          />
          <PublicRoute
            exact
            path="/verify/:studentId"
            component={StudentVerify}
          />
          <PublicRoute
            exact
            path="/viewStudent/:email/:password"
            component={ViewStudent}
          />
          <PrivateRoute exact path="/noaccess" component={NoAccess} />
          <PrivateRoute exact path="/settings" component={Settings} />
          <PrivateRoute exact path="/test" component={Test} />
          <PrivateRoute exact path="/home/:tab?/:type?" component={HomePage} />
          <PrivateRoute exact path="/administration/phone" component={Phone} />
          {/* <PrivateRoute exact path="/profile" component={ProfilePage} /> */}
          <PrivateRoute exact path="/profile" component={NewProfilePage} />
          {/* <PrivateRoute exact path="/website_management" component={Website} /> */}
          <PrivateRoute
            exact
            path="/administration"
            component={SystemAdministration}
          />
          <PrivateRoute
            exact
            path="/systemAdministration/userManagement/:tab/:id?/:subTab?/:type?"
            component={SystemAdministration}
          />
          <PrivateRoute
            exact
            permission="bmview"
            path="/administration/brandSetting/list"
            component={BrandManagement}
          />
          <PrivateRoute
            exact
            permission="bmview"
            path="/administration/brandSetting/auditTrail"
            component={AuditTrailBrand}
          />
          <PrivateRoute
            exact
            permission="bmview"
            path="/administration/brandSetting/singleAuditTrail/:id"
            component={SingleAuditTrailBrand}
          />
          <PrivateRoute
            exact
            permission="bmadd"
            path="/administration/brandSetting/addNewBrand"
            component={AddNewBrand}
          />
          <PrivateRoute
            exact
            permission="bmadd"
            path="/administration/brandSetting/addPortalSetting/:id"
            component={AddPortalSetting}
          />
          <PrivateRoute
            exact
            path="/administration/brandSetting/editBrand/:id"
            component={EditBrand}
          />
          <PrivateRoute
            exact
            permission="bmadd"
            path="/administration/brandSetting/addPortalSetting/detailsTab/:id"
            component={DetailTab}
          />
          <PrivateRoute
            exact
            permission="bmadd"
            path="/administration/brandSetting/addPortalSetting/visualsTab/:id"
            component={VisualsTab}
          />
          <PrivateRoute
            exact
            path="/administration/brandSetting/editPortalSetting/detailsTab/:id"
            component={DetailTab}
          />
          <PrivateRoute
            exact
            path="/administration/brandSetting/editPortalSetting/visualsTab/:id"
            component={VisualsTab}
          />
          <PrivateRoute exact path="/addnewuser" component={AddNewUser} />
          <PrivateRoute
            exact
            path="/systemAdministration/permissionManagement/:tab/:id?/:subTab?"
            component={PermissionManagement}
          />
          <PrivateRoute
            exact
            path="/systemAdministration/:sideTab/:tab/:id?/:subTab?"
            component={SystemAdministration}
          />
          <PrivateRoute
            exact
            permission="umadd"
            path="/addnewuser"
            component={AddNewUser}
          />
          <PrivateRoute exact path="/edituser" component={EditUser} />
          <PrivateRoute
            exact
            // permission="shview"
            path="/support/student-hub-library/student-hub/:page"
            component={StudentHubManagement}
          />
          <PrivateRoute
            exact
            path="/support/student-hub-library/student-hub/open/:id"
            component={TabDetail}
          />
          <PrivateRoute
            exact
            path="/support/student-hub-library/student-hub/duplicateStudentTabList/:id"
            component={CreateTab}
          />
          <PrivateRoute
            exact
            path="/support/student-hub-library/student-hub/open/:actionId/:audittrail"
            component={AuditTrail}
          />

          <PrivateRoute
            exact
            permission="stuhmsadd"
            path="/support/student-hub-library/student-hub/:tabId/section/create/new"
            component={CategoriesTabList}
          />
          <PrivateRoute
            exact
            permission="stuhmsedit"
            path="/support/student-hub-library/student-hub/:tabId/section/open/:id"
            component={CategoriesTabList}
          />
          <PrivateRoute
            exact
            path="/support/student-hub-library/student-hub/:tabId/section/duplicateCategory/:id"
            component={CategoriesTabList}
          />
          <PrivateRoute
            exact
            path="/support/student-hub-library/student-hub/:tabId/section/:catId/resource/create"
            component={ResourcesTabList}
          />
          <PrivateRoute
            exact
            path="/support/student-hub-library/student-hub/:tabId/section/:catId/resource/open/:id"
            component={ResourcesTabList}
          />
          <PrivateRoute
            exact
            // permission="shview"
            path="/support/student-hub-library/:tab/:type/:id?/:editType?/:resourceType?"
            component={ResourceManagement}
          />
          <PrivateRoute
            exact
            path="/courseAdministration/coursesdetails/:id/:type"
            component={AddNewCourse}
          />
          <PrivateRoute
            exact
            path="/courseAdministration/courses/addcourse"
            component={AddNewCourse}
          />
          <PrivateRoute
            exact
            // permission="cview"
            path="/courseAdministration/gradingTemplate/:tab/:id?"
            component={TemplateTable}
          />
          <PrivateRoute
            exact
            path="/courseAdministration/coursesdetail/:id/students/:tab/:stdId"
            component={StudentGradebookRedirect}
          />
          {/* Call Dashboard - handles both tokenized URLs (external) and phone numbers (authenticated) */}
          <PublicRoute
            exact
            path='/callDashboard/:param'
            component={CallDashboard}
            noLogin={true}
          />
          <PrivateRoute
            exact
            permission="cview"
            path="/courseAdministration/courses/:tab"
            component={Courses}
          />
          <PrivateRoute
            exact
            permission="cbview"
            path="/courseAdministration/:tab"
            component={BookedCourses}
          />
          <PrivateRoute
            exact
            permission="cbview"
            path="/courseAdministration/bookedcourses/:tab/:id"
            component={OpenCourseBookings}
          />
          <PrivateRoute
            exact
            // permission="cview"
            path="/courseAdministration/certificates/:tab/:id?"
            component={CertificateTemplate}
          />
          <PrivateRoute
            exact
            // permission="cview"
            path="/courseAdministration/coursesdetails/duplicateTemplate"
            component={DuplicateTemplate}
          />
          <PrivateRoute
            exact
            path="/studentadministration/heqcis"
            component={HEQCIS}
          />
          <PrivateRoute
            exact
            path="/courseAdministration/coursesdetails/:id/:tab/:type/:subTab?/:openTabs?/:subId?/:subType?/:subSubId?/:tabList?/:tabType?/:attemptId?"
            component={DetailCourses}
          />
          <PrivateRoute
            exact
            path="/courseAdministration/registration/:page/:tab?/:id?"
            component={ReRegistration}
          />
          <PrivateRoute
            exact
            permission="cquestionbadd"
            path="/courseAdministration/smartAssessment/questionBank/question/duplicate/:id"
            component={DuplicateQuestion}
          />
          <PrivateRoute
            exact
            permission="cquestionbadd"
            path="/courseAdministration/smartAssessment/addquestion/:id?"
            component={AddQuestion}
          />
          <PrivateRoute
            exact
            permission="cquizmadd"
            path="/courseAdministration/assessment/quiz/addquiz"
            component={AddAssessment}
          />
          <PrivateRoute
            exact
            permission="cquizmadd"
            path="/courseAdministration/quizzes/duplicateassessment/:id"
            component={AddAssessment}
          />
          <PrivateRoute
            exact
            path="/courseAdministration/smartAssessment/:tabName?/:tab?/:subtab?/:id?/:subId?"
            component={Courses}
          />
          <PrivateRoute
            exact
            path="/courseAdministration/assessment/:tabName?/:tab?/:subtab?/:id?/:subId?"
            component={Courses}
          />
          <PrivateRoute exact path="/gdc" component={HomePage} />
          <PrivateRoute
            exact
            path="/courseAdministration/Programmes/:tab/:type?/:id?/:subtype?/:subId?/:subTab?/:openTabs?"
            component={Programs}
          />
          <PrivateRoute
            exact
            path="/websiteManagement/pages/programmes_and_short_courses/:tab/:subTab/:type?/:id?"
            component={ProgrammeShortCourse}
          />
          <PrivateRoute
            exact
            path="/courseAdministration/gradeMix/:id?/:tab/:subId?/:type"
            component={GradeMix}
          />
          <PrivateRoute exact path="/gdc" component={HomePage} />
          <PrivateRoute exact path="/status" component={StudentStatus} />
          <PrivateRoute
            exact
            permission="pmview"
            path="/permissionManagement"
            component={PermissionManagement}
          />
          <PrivateRoute
            exact
            path="/systemAdministration/permissionManagement/:tab/:type?/:roleName?/:id?"
            component={PermissionManagement}
          />

          <PrivateRoute
            exact
            path="/administration/netsuite/:tab/:type?/:id?"
            component={NetsuiteManagement}
          />
          <PrivateRoute
            exact
            path="/notification/email/:tab/:type/:id?"
            component={EmailManagement}
          />
          <PrivateRoute
            exact
            path="/notification/bulknotification/:tab/:type/:id?"
            component={Notification}
          />
          <PrivateRoute exact path="/content" component={ContentAssemblies} />
          <PrivateRoute
            exact
            path="/contentassembliesdetails/create"
            component={AssembliesDetails}
          />
          <PrivateRoute
            exact
            path="/contentassembliesdetails/edit"
            component={AssembliesDetails}
          />
          <PrivateRoute
            exact
            path="/contentassembliesdetails/duplicate"
            component={AssembliesDetails}
          />
          <PrivateRoute
            exact
            path="/content/resourcedetails"
            component={ResourcePoolDetails}
          />
          <PrivateRoute
            exact
            path="/project-center/:sideTab/:type/:id?"
            component={ProjectCenter}
          />
          <PrivateRoute
            exact
            path="/career-library/:sideTab/:type/:id?/:tab?"
            component={CareerLibrary}
          />
          <PrivateRoute
            exact
            path="/program-management-center"
            component={ProgramManagementCenter}
          />
          
          <PrivateRoute
            exact
            path="/program-management-center/:sideTab/:tab/:type/:id?/:subId?"
            component={ProgramManagementCenter}
          />
          <PrivateRoute
            exact
            path="/program-management-center/exportProgramme/:id"
            component={ExportPDF}
          />

          {/* routes by yash start */}
          <PrivateRoute
            exact
            path="/courses/content/:tab/:type/:id?/:subType?/:subId?"
            component={ContentAssemblies}
            permission="caview"
          />
          <PrivateRoute
            exact
            path="/content/:tab/:type/:resourcePoolId/:subTab/:subTabType?/:subTabId?"
            component={ResourcePoolSubCatDetails}
          />

          {/* routes by yash end */}

          <PrivateRoute
            exact
            permission="sslciew"
            path="/support/live-chat"
            component={LiveChat}
          />
          <PrivateRoute
            exact
            path="/support/:tab?"
            component={SupportAdministration}
          />
          <PrivateRoute
            exact
            permission="tview"
            path="/support"
            component={SupportAdministration}
          />
          <PrivateRoute exact path="/addticket" component={AddTicket} />
          <PrivateRoute
            exact
            path="/addticketStudent/:id/:stdName"
            component={AddTicket}
          />
          <PrivateRoute exact path="/editticket/:id" component={ViewTicket} />
          <PrivateRoute
            exact
            path="/editticket/:id/audittrial"
            component={(props) => <ViewTicket {...props} purpose="ticketaudit" />}
          />

          <PrivateRoute
            exact
            path="/studentAdministration/students/:type/:id?/:tab?/:subType?/:subId?"
            component={StudentAdministration}
          />
          <PrivateRoute
            exact
            path="/campusAdministration/bookings/:type/:id?"
            component={BookingManagement}
          />
          <PrivateRoute
            exact
            path="/campusAdministration/schedule/calender"
            component={ScheduleManagement}
          />
          <PrivateRoute
            exact
            path="/campusAdministration/smartsignage/:tab/:type?/:id?"
            component={SmartSignage}
          />
          <PrivateRoute
            exact
            path="/studentAdministration/externalExam/:tab/:type?/:subTab?/:id?/:subType?/:subId?"
            component={ExternalExamReg}
          />
          <PrivateRoute
            exact
            path="/studentadministration/registration/:page/:tab?/:id?"
            component={ReRegistration}
          />
          <PrivateRoute
            exact
            path="/courseAdministration/articulation/:page/:tab?/:id?"
            component={ProgramArticulations}
          />
          <PrivateRoute
            exact
            path="/courseAdministration/intake-qualification/:page/:tab?/:id?"
            component={IntakeCopy}
          />
          <PrivateRoute
            exact
            permission="pmview"
            path="/permissionManagement"
            component={PermissionManagement}
          />
          <PrivateRoute
            exact
            path="/administration/netsuite/mergedData/table/:subTab"
            component={NetsuiteManagement}
          />
          <PrivateRoute
            exact
            path="/administration/netsuite/:tab/:type?/:id?"
            component={NetsuiteManagement}
          />
          <PrivateRoute
            exact
            path="/administration/general/:tab"
            component={General}
          />
          <PrivateRoute
            exact
            path="/administration/serverManagement/:tab"
            component={ServerManagement}
          />
          <PrivateRoute
            exact
            path="/administration/classManagement/:tab"
            component={ClassManagement}
          />
          <PrivateRoute
            exact
            path="/administration/campusManagement/:tab"
            component={CampusManagement}
          />
          <PrivateRoute
            exact
            path="/administration/softphoneManagement/:tab"
            component={SoftphoneManagement}
          />
          <PrivateRoute
            exact
            permission="tsview"
            path="/administration/ticketSettings/:tab/:type?/:id?"
            component={TicketSetting}
          />
          <PrivateRoute
            exact
            path="/websiteManagement/siteSetup/:type"
            component={Website}
          />
          <PrivateRoute
            exact
            path="/websiteManagement/siteSetup/brand_Templates/:type/:subType?/:subId?"
            component={CreateBrandTemplate}
          />
          <PrivateRoute
            exact
            path="/websiteManagement/siteSetup/table/:type/:id?"
            component={AddWebsiteList}
          />
          <PrivateRoute
            exact
            path="/websiteManagement/events/:tab/:type"
            component={Events}
          />
          <PrivateRoute
            exact
            path="/websiteManagement/events/landing_page/:tab/:subTab?/:subId?"
            component={LandingPageTabs}
          />
          <PrivateRoute
            exact
            path="/websiteManagement/events/upcoming_events/:tab/:subTab?/:subId?"
            component={UpcomingEventsTabs}
          />
          <PrivateRoute
            exact
            path="/websiteManagement/events/info_packs/:tab/:subTab?/:subId?"
            component={InfoPacksTabs}
          />
          <PrivateRoute
            exact
            path="/websiteManagement/layout_navigation/:tab/:type"
            component={LayoutNavigation}
          />
          <PrivateRoute
            exact
            path="/websiteManagement/layoutNavigation/testimonials/:tab/:subTab?/:subId?"
            component={CreateLayoutTestimonial}
          />
          <PrivateRoute
            exact
            path="/websiteManagement/layout_navigation/:tab/:subTab?/:type/:subId?"
            component={CategoryTabs}
          />

          {/* pages route */}

          <PrivateRoute
            exact
            path="/website_management/pages/staticpages/:tab"
            component={StaticPages}
          />
          <PrivateRoute
            exact
            path="/website_management/pages/staticpages/table/:tab/:id?"
            component={CreateStaticPages}
          />
          <PrivateRoute
            path="/website_management/pages/campuspages/table/:type/:id?"
            component={CreateCampusPages}
          />
          <PrivateRoute
            exact
            path="/website_management/pages/campuspages/:tab"
            component={CampusPages}
          />
          <PrivateRoute
            exact
            path="/website_management/pages/popupspages/table/:type/:id?"
            component={CreatePopupsPages}
          />
          <PrivateRoute
            exact
            path="/website_management/pages/popupspages/:tab"
            component={PopupsPages}
          />
          <PrivateRoute
            exact
            path="/website_management/pages/emailspages/table/:type/:id?"
            component={CreateEmailsPages}
          />
          <PrivateRoute
            exact
            path="/website_management/pages/emailspages/:tab"
            component={EmailsPages}
          />
          <PrivateRoute
            exact
            path="/website_management/partners/table"
            component={PartnerManagement}
          />
          <PrivateRoute
            exact
            path="/website_management/partnerDetails/:id"
            component={PartnerDetails}
          />
          <PrivateRoute
            exact
            permission="partnerview"
            path="/website_management/partners/auditTrail"
            component={AuditTrailPartner}
          />
          <PrivateRoute
            exact
            path="/website_management/pages/categorylandingpages/table/:type/:id?"
            component={CreateCategoryLandingPages}
          />
          <PrivateRoute
            exact
            path="/website_management/pages/categorylandingpages/:tab"
            component={CategoryLandingpages}
          />
          <PrivateRoute
            exact
            path="/website_management/pages/courselandingpages/:tab"
            component={CourseLandingPages}
          />
          <PrivateRoute
            exact
            path="/website_management/pages/courselandingpages/table/:type/:id?"
            component={CreateCourseLandingPages}
          />
          <PrivateRoute
            exact
            path="/website_management/pages/blogandnews/:tab"
            component={BlogAndNews}
          />
          <PrivateRoute
            exact
            path="/website_management/pages/blogandnews/table/:type/:id?"
            component={CreateBlogAndNewsPages}
          />
          <PrivateRoute
            exact
            path="/supportAdministration/:sideTab/:tab/:type/:id?"
            component={Appeals}
          />
          <PrivateRoute
            exact
            path="/studentAdministration/students/:type/:id?/:tab?/:subType?"
            component={StudentAdministration}
          />
          <PrivateRoute
            exact
            path="/systemAdministration/:sideTab/:tab/:type?/:roleName?/:id?"
            component={PermissionManagement}
          />

          <PrivateRoute
            exact
            path="/studentadministration/:page/:tab?"
            component={ReRegistration}
          />
          <PrivateRoute
            exact
            path="/administration/netsuite/customers/:type?/:id?"
            component={NetsuiteManagement}
          />

          <PrivateRoute
            exact
            path="/systemAdministration/permissionManagement/:tab/:type?/:roleName?/:id?"
            component={PermissionManagement}
          />
          <PrivateRoute
            exact
            path="/classReport/:tab/:intake/:cid"
            component={ClassReport}
          />
          <PrivateRoute exact path="/fileSystem" component={FileSystem} />
          <PrivateRoute
            exact
            path="/DashBoardDesign1"
            component={DashBoardDesign1}
          />
          <PrivateRoute
            exact
            permission="cview"
            path="/courseAdministration/coursesDeon/:tab"
            component={CoursesDeonDesign}
          />
          <PrivateRoute
            exact
            permission="cview"
            path="/courseAdministration/coursesDeonUnknown/:tab"
            component={CoursesDeonDesignUnknown}
          />
        </Switch>
      </Router>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
